// extracted by mini-css-extract-plugin
export default {"home":"Home_home__njv-n"};